import { Badge } from "@/components/ui/badge";

const MAP = {
    paid: "bg-emerald-50 text-emerald-700",
    initiated: "bg-amber-50 text-amber-700",
    unpaid: "bg-amber-50 text-amber-700",
    not_required: "bg-slate-100 text-slate-700",
    expired: "bg-rose-50 text-rose-700",
};

export default function PaymentBadge({ status }) {
    return (
        <Badge className={`${MAP[status] || "bg-slate-100 text-slate-700"} rounded-full font-medium`}>
            {status?.replaceAll("_", " ")}
        </Badge>
    );
}
